import { createContext } from "react";

const shoppingContext = createContext();

export default shoppingContext;
